<template>
  <div class="d-flex flex-column">
    <div class="row no-gutters mt-auto">
      <div class="col text-right">
        <p class="text font-weight-bold">
          <a class="url" target="_blank" :href="'http://' + project.url">{{ project.url }}</a>
        </p>
      </div>
    </div>
    <div class="row no-gutters mb-auto">
      <div class="d-flex flex-column align-items-center h-100 m-auto">
          <div class="monitor-placeholder">
            <aspect-ratio-box ratio="16:9">
              <transition name="fade" mode="out-in">
                <img :alt="project.nombre"
                     :key="`web_project_${project.nombre}`"
                       :src="project.foto"
                       :title="project.nombre"
                       class="img-fluid w-100"/>
              </transition>
            </aspect-ratio-box>
          </div>
        <img :src="imgKeyboard" alt="" class="w-100"/>
      </div>
    </div>
    <div class="row no-gutters text-orange align-bottom mt-2 mt-sm-0">
      <div class="col-12 col-sm text-country-date text-center text-sm-left">
        <p class="text mb-0">
          <span class="font-weight-bold">{{ project.pais }}</span>
          -
          {{ project.fecha }}
        </p>
      </div>
      <div class="col-12 col-sm text-center text-sm-right">
        <p class="text text-name mb-0">{{ project.nombre }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import AspectRatioBox from './AspectRatioBox'
  import imgKeyboard from '../assets/images/portfolio/portfolioWeb/laptop_keyboard.webp'

  export default {
    name: 'PortfolioWebProject',
    components: { AspectRatioBox },
    data () {
      return {
        imgKeyboard
      }
    },
    props: {
      project: {
        type: Object,
        default () {
          return {
            foto: null,
            nombre: '',
            url: '',
            pais: '',
            fecha: ''
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/styles/colors";

  .text {
    font-family: "Open Sans", sans-serif;
  }

  .url {
    font-size: 1.5rem;
    font-family: "Open Sans", sans-serif;
    text-shadow: 1px 2px #ffffff78;
    color: $blue-accent;
    cursor: pointer;
  }

  .text-orange {
    color: $light-orange;
  }

  .text-country-date {
    font-size: 1.9rem;
  }

  .text-name {
    font-size: 2.2rem;
    font-weight: 800;
  }

  .monitor-placeholder {
    background: #111010;
    flex-grow: 1;
    border-radius: 25px;
    width: 88%;
    position: relative;
    padding: 2%
  }
</style>



// WEBPACK FOOTER //
// src/components/PortfolioWebProject.vue